import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, XCircle, Sparkles, CheckCircle } from 'lucide-react';
import { SectionWrapper } from './ui/SectionWrapper';
export function ProblemSolution() {
  return <SectionWrapper background="slate" data-id="element-231">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16" data-id="element-232">
        {/* Problem Column */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white p-8 rounded-2xl shadow-sm border border-red-100" data-id="element-233">
          <div className="flex items-center gap-2 mb-6 text-red-500 font-semibold" data-id="element-234">
            <AlertTriangle className="h-5 w-5" data-id="element-235" />
            <h3 data-id="element-236">¿Te suena familiar?</h3>
          </div>
          <ul className="space-y-4" data-id="element-237">
            {['No sé por dónde empezar ni qué modelo de Amazon me conviene', 'Me da miedo invertir sin entender las tarifas y costos reales', 'No tengo idea de cómo encontrar proveedores confiables', 'Hay tanta información contradictoria que me paralizo'].map((item, i) => <li key={i} className="flex items-start gap-3 text-slate-600" data-id="element-238">
                <XCircle className="h-5 w-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-239" />
                <span data-id="element-240">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        {/* Solution Column */}
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-white p-8 rounded-2xl shadow-md border border-emerald-100 ring-1 ring-emerald-50" data-id="element-241">
          <div className="flex items-center gap-2 mb-6 text-emerald-600 font-semibold" data-id="element-242">
            <Sparkles className="h-5 w-5" data-id="element-243" />
            <h3 data-id="element-244">Este ebook te da el mapa</h3>
          </div>
          <ul className="space-y-4" data-id="element-245">
            {['Comparación clara de cada modelo con pros, contras y presupuesto mínimo', 'Desglose real de costos, tarifas FBA y cómo calcular tu margen', 'Guía paso a paso para encontrar y evaluar proveedores (con red flags)', 'Plan de 30 días con acciones concretas, sin teoría innecesaria'].map((item, i) => <li key={i} className="flex items-start gap-3 text-slate-700 font-medium" data-id="element-246">
                <CheckCircle className="h-5 w-5 text-emerald-500 flex-shrink-0 mt-0.5" data-id="element-247" />
                <span data-id="element-248">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </SectionWrapper>;
}